// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","registrationButton":"_30d4S8z2FqjJYcmGyOLom8","registered":"_1gP631j0J51FtAJbBy4Jiy","couponCode":"_3B7rwtUz8iBgt7ciZL-jN0"};